import { Map as IMap, fromJS } from 'immutable';
import { createSelector } from 'reselect';
import { DEFAULT_CURRENCY_CODE } from '../constants/constants';

export const getIntl = state => state.get('intl');
export const LOYALTY_HELP_MESSAGE_ID = 'loyalty.loyaltyMessages.loyaltyHelpText';
export const LOYALTY_IMAGE_SRC_MESSAGE_ID = 'loyalty.loyaltyMessage.logoSrc';
export const CHECKOUT_SUB_HEADER_TEXT_MESSAGE_ID = 'checkout.checkoutMessages.checkoutSubHeaderText';

export const CHECKOUT_SUB_HEADER_TEXT_PHYSICAL_MESSAGE_ID = 'checkout.checkoutMessages.checkoutSubHeaderTextPhysical';
export const CHECKOUT_SUB_HEADER_TEXT_PRINT_AT_HOME_MESSAGE_ID = 'checkout.checkoutMessages.checkoutSubHeaderTextPrintAtHome';

export const intlSelector = (state) => {
    const intl = state.get('intl');
    let returnIntl = intl;
    if (IMap.isMap(intl)) {
        returnIntl = intl.toJS();
    }
    return returnIntl;
};

export const intlMessages = createSelector(
    intlSelector,
    intl => ({
        ...intl.messages
    })
);

export const messages = createSelector(
    intlMessages,
    intl => fromJS(intl)
);

export const getLoyaltyHelpText = createSelector(
    messages,
    msgs => msgs.get(LOYALTY_HELP_MESSAGE_ID, null)
);

export const getLoyaltyImageSrc = createSelector(
    messages,
    msgs => msgs.get(LOYALTY_IMAGE_SRC_MESSAGE_ID, '')
);

/**
 * Get the current locale.
 *
 * @param {Immutable.Map} state - The current redux state.
 * @returns {string|undefined} the current locale (i.e. 'en-us', 'fr-ca', 'ja-jp')
 */
export const getIntlLocale = createSelector(
    intlSelector,
    intl => fromJS(intl).get('locale')
);

export const formats = createSelector(
    intlSelector,
    intl => fromJS(intl).get('formats', IMap())
);

export const getTestEnvMessages = createSelector(
    messages,
    intlTestMessages => intlTestMessages.get('testEnvironmentBannerMessages.testEnvironmentBannerMessage', null)
);

export const getCurrencyFormat = createSelector(
    formats,
    intlFormats => intlFormats.getIn(['number', 'currency'], IMap())
);

export const getIntlCurrencyCode = createSelector(
    getCurrencyFormat,
    currencyFormat => currencyFormat.get('currency', DEFAULT_CURRENCY_CODE)
);


export const getPhysicalCardDescriptionMessages = createSelector(
    messages,
    msgs => ({
        physicalCardDescriptionLabel_1:
         getCleanMessage(msgs, 'giftCardDetailsPageV2.giftCardDetailsPageMessages.physicalCardDescriptionLabel_1'),
        physicalCardDescriptionLabel_2:
         getCleanMessage(msgs, 'giftCardDetailsPageV2.giftCardDetailsPageMessages.physicalCardDescriptionLabel_2'),
        physicalCardDescriptionLabel_3:
         getCleanMessage(msgs, 'giftCardDetailsPageV2.giftCardDetailsPageMessages.physicalCardDescriptionLabel_3')
    })
);

export const getCheckOutSubHeaderTextDigital = createSelector(
    messages,
    msgs => msgs.get(CHECKOUT_SUB_HEADER_TEXT_MESSAGE_ID, null)
);

export const getCheckOutSubHeaderTextPhysical = createSelector(
    messages,
    msgs => msgs.get(CHECKOUT_SUB_HEADER_TEXT_PHYSICAL_MESSAGE_ID, null)
);

export const getCheckOutSubHeaderTextPrintAtHome = createSelector(
    messages,
    msgs => msgs.get(CHECKOUT_SUB_HEADER_TEXT_PRINT_AT_HOME_MESSAGE_ID, null)
);


function getCleanMessage(msgs, key) {
    const msg = msgs.get(key, '');
    return (typeof msg === 'string' && msg.trim().length > 0) ? msg : null;
}
